import {initForm, submitAndValidationForm} from "./generalForm.js";
import {handlePasswordInput} from "./passwordInput.js"

("use strict")
;(() => {

    handlePasswordInput()

    const checkAge = (birthday) => {
        const diff = new Date().getTime() - new Date(birthday).getTime()
        /*Dividing diff in milliseconds by 31556952000 (milliseconds in a year) to convert the milliseconds to years. */
        const diffYears = diff / 31556952000
        return diffYears >= 16;
    }

    const className = "validation-register-form"

    const form = initForm(className)

    const formElements = [
        {
            element: form.querySelector("#firstname")
        },
        {
            element: form.querySelector("#lastname")
        },
        {
            element: form.querySelector("#address1")
        },
        {
            element: form.querySelector("#address2")
        },
        {
            element: form.querySelector("#zipCode")
        },
        {
            element: form.querySelector("#city")
        },
        {
            element: form.querySelector("#email")
        },
        {
            element: form.querySelector("#telephone")
        },
        {
            element: form.querySelector("#birthday"),
            validation: [
                (element) => {
                    if (!checkAge(element.value))
                        return "Du musst mindestens 16 Jahre alt sein"
                    return ""
                }
            ]
        },
        {
            element: form.querySelector("#password")
        },
        {
            element: form.querySelector("#passwordConfirmation"),
            validation: [
                (element) => {
                    if (form.querySelector("#password").value !== element.value)
                        return "Passwörter stimmen nicht überein"
                    return ""
                }
            ]
        },
        {
            element: form.querySelector("#consentData")
        },
        {
            element: form.querySelector("#country")
        }
    ]

    submitAndValidationForm(form, formElements)
})()
